import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { apexChartOptions } from 'src/app/views/pages/dashboardv2/dashboardv2-iso.component';

@Component({
  selector: 'app-card-modal-widget',
  templateUrl: './card-modal-widget.component.html',
  styleUrls: ['./card-modal-widget.component.scss']
})
export class CardModalWidgetComponent implements OnInit {
  
  @Input() modalTitle:string;
  @Input() loaderId:string;
  @Input() isChartShow:any;
  @Input() isChart2Show:any;
  @Input() isStateShow:boolean;
  @Input() isShowLabel:boolean;
  @Input() show12Month:boolean;
  @Input() dropdownBtn = true;
  @Input() isShowDevice:boolean=false;
  @Input() isShowCustomer:boolean=false;
  @Input() isShowLabeltransaction:boolean=false;
  @Input() isGeoLocation:boolean = true;
  @Input() isShowprocessor:boolean = true;
  @Input() isCardShow:boolean = true;
  @Input() isShowSalesPerson:boolean = true;
  @Input() isShowMode:boolean = true;
  @Input() apexChartSPCustomers:Partial<apexChartOptions>;
  @Input() apexChart2Show:Partial<apexChartOptions> = {};
  @Input() configUSChart:ZingchartAngular.graphset = {};
  @Input() swapLabel: string;
  @Output() closeModal = new EventEmitter<any>();
  @Output() viewBySummary = new EventEmitter<any>();
  @Output() salesperson = new EventEmitter<any>();
  @Output() geoLocation = new EventEmitter<any>();
  @Output() viewByCustomer = new EventEmitter<any>();
  @Output() deviceType = new EventEmitter<any>();
  @Output() cardType = new EventEmitter<any>();
  @Output() viewByChannel = new EventEmitter<any>();
  @Output() viewByMode = new EventEmitter<any>();
  @Output() viewByProcessor = new EventEmitter<any>();
  value:boolean = false;
  showChart:boolean = false;
  constructor() { }

  ngOnInit(): void {
  }
  oncloseModal(){
    this.closeModal.emit();
  }
  onviewBySummary(event:Event){
    event.preventDefault();
    this.viewBySummary.emit();
  }
  onSalesperson(event:Event){
    event.preventDefault();
    this.salesperson.emit();
  }
  onLocation(event:Event){
    if (this.value){
      this.isChartShow = false
    } 
    event.preventDefault();
    this.geoLocation.emit();
  }
  onviewByCustomer(event:Event){
    event.preventDefault();
    this.viewByCustomer.emit();
  }
  onDeviceType(event:Event){
    if(this.showChart){
      this.isChartShow = false;
      this.isChart2Show = true;
    }
    event.preventDefault();
    this.deviceType.emit();
  }
  onCardType(event:Event){
    event.preventDefault();
    this.cardType.emit();
  }
  onviewByChannel(event:Event){
    event.preventDefault();
    this.viewByChannel.emit();
  }
  onviewByMode(event:Event){
    event.preventDefault();
    this.viewByMode.emit();
  }
  onviewByProcessor(event:Event){
    event.preventDefault();
    this.viewByProcessor.emit();
  }

  toggleCharts() {
      this.isChartShow = !this.isChartShow;
      this.isChart2Show = !this.isChart2Show;
      this.value = true;
      this.showChart = this.isChartShow ? true:false;      
    }

}
